
import Vue from "vue";
import AppBar from "@/shared/components/AppBar.vue";
import AppSnackbar from "@/shared/components/AppSnackbar.vue";

export default Vue.extend({
    name: "App",
    data: () => ({
        showSnackbar: false,
        snackbarMessage: "",
    }),
    components: {
        AppBar,
        AppSnackbar,
    },
    methods: {
        displaySnackbar(message: string) {
            console.log("Displaying snackbar");
            this.showSnackbar = true;
            this.snackbarMessage = message;
        },
    },
});
